import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Parola trebuie să aibă minim 6 caractere");
    if (pw !== confirm) return toast.error("Parolele nu coincid");
    setBusy(true);
    try {
      const r = await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(r.data.message || "Parolă resetată");
      nav("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Eroare la resetare");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B111D] p-8">
      <div className="w-full max-w-md fade-up" data-testid="reset-password-form">
        <Link to="/" className="flex items-center gap-3 font-display text-2xl font-extrabold tracking-tight justify-center mb-8">
          <img src="/brand/logo-icon.png" alt="IronOfferAI" className="w-11 h-11 rounded-lg" />
          IronOfferAI
        </Link>
        <div className="card-flat p-8">
          <div className="overline mb-3">Resetare parolă</div>
          <h1 className="font-display text-2xl font-extrabold tracking-tight">Setează o parolă nouă</h1>
          {!token ? (
            <div className="mt-6 p-4 bg-[#EF4444]/10 border-l-2 border-[#EF4444] text-sm text-[#CBD5E1]" data-testid="reset-no-token">
              Link invalid. Solicită din nou resetarea din pagina de <Link to="/login" className="text-[#00BFFF] font-semibold hover:underline">autentificare</Link>.
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <label className="overline block mb-2">Parola nouă</label>
                <input data-testid="reset-new-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="input-flat" placeholder="••••••••" />
              </div>
              <div>
                <label className="overline block mb-2">Confirmă parola</label>
                <input data-testid="reset-confirm-password" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-flat" placeholder="••••••••" />
              </div>
              <button type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-50" data-testid="reset-submit">
                {busy ? "Se resetează..." : "Resetează parola"}
              </button>
              <Link to="/login" className="block text-center text-sm text-[#94A3B8] hover:text-[#00BFFF]">Înapoi la autentificare</Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
